module.exports = __webpack_public_path__ + "img/icon-flag-united-kingdom.015a5fdb.png";